<script setup lang="ts">
import { HomeButton } from '@/components/home';
import { useDailyUpChallenge } from '@/composables/game/challenges';
import { twMerge } from 'tailwind-merge';

withDefaults(defineProps<{
  containerClass?: string
}>(), {
  containerClass: '',
})

const { counterToNextDay, dailyUpChallenge } = useDailyUpChallenge()
</script>

<template>
  <HomeButton
    v-if="dailyUpChallenge"
    label="Daily up"
    :countdown="{ value: counterToNextDay, dangerThreshold: 3600 * 3 }"
    :show-sparkle="true"
    :button-class="twMerge('bg-[linear-gradient(180deg,#FF9D0A_0.01%,#4E5EB8_16.5%,#000_42.5%)] p-0.5', containerClass)"
  >
    <template #blur-effect>
      <div class="absolute top-1/2 left-1/2 size-8 red-blur rounded-full -translate-y-1/2 -translate-x-1/2 z-[1]" />
    </template>
    <img
      class="size-10 object-cover z-[3]"
      src="@/assets/images/gifs/trophy.gif"
    >
  </HomeButton>
</template>

<style scoped>
.red-blur {
  background: rgba(231, 46, 109, 0.68);
  filter: blur(9px);
}
</style>
